import { useTranslations } from '@crystal/translator'
import { FC } from 'react'

import styles from './account-portal.module.scss'

export const ErrorView: FC<{ error?: boolean }> = ({ error }) => {
  const t = useTranslations()
  return <>{error && <p className={styles.error}>{t('unknownError.message')}</p>} </>
}
